import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getOne from 'utils/getOne'

interface useInitProps {
  setDataLoaded: Function
  setShowOverlay: Function
  reset: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getOne(apiUrls.settings + '/' + apiUrls.actionEmailNotification).then((data) => {
      props.reset({
        email: data?.email ?? null
      })
      props.setDataLoaded(true)
      props.setShowOverlay(false)
    })

    
  }, [props.currentCustomer])
}

export default useInit
